export type EventTypeString = 'CLOSE';

export const eventType: EventTypeString = 'CLOSE';

export type EventType = {
  type: EventTypeString,
};

export const eventBuilder = (): EventType => ({
  type: eventType,
});
